export default class TextHelper {
  static capitalizeFirstLetter(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  static truncate(text: string, maxLength: number): string {
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  }

  static snakeToCamelCase(text: string): string {
    const removedUnderlinesText =  text.replace(/_([a-z])/g, (g)  => g[1].toUpperCase());
    return removedUnderlinesText.charAt(0).toLowerCase() + removedUnderlinesText.slice(1);
  }

  static snakeCaseToSpaces(label, ucFirst) {
    label = label.replace(/_/g, ' ');
    return ucFirst ? label[0].toUpperCase() + label.slice(1) : label;
  }

  static camelCaseToSpaces(label, ucFirst) {
    label = label.replace(/([A-Z]+)/g, ' $1').toLowerCase();
    return ucFirst ? label[0].toUpperCase() + label.slice(1) : label;
  }

  static toArray(string) {
    return string.split(',').map(el => el.trim());
  }
}
